import { render, staticRenderFns } from "./SelectCom.vue?vue&type=template&id=24821eff&scoped=true"
import script from "./SelectCom.vue?vue&type=script&lang=js"
export * from "./SelectCom.vue?vue&type=script&lang=js"
import style0 from "./SelectCom.vue?vue&type=style&index=0&id=24821eff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24821eff",
  null
  
)

export default component.exports